import { BSC_ABI, SALE_ABI } from '@lfg/abis';
import { useCallback } from 'react';
import { useAccount } from 'wagmi';
import { useWatchContractEvent } from 'wagmi';
import { getBlock } from 'wagmi/actions';

import { NODE_SALE_V1_SC_ADDRESS } from '@/global/configs/common.config';
import { useAppSelector } from '@/store/utils';

import type { UseWatchBuyEventsProps } from './types/buyNode.type';

// const BUY_EVENTS = ['BuyByETH', 'BuyByLIX', 'buyByGala', 'buyByUSDC', 'buyByUSDT'] as const;
// const BUY_EVENTS_BSC = ['BuyByETH', 'BuyByLIX', 'BuyByUSDC', 'BuyByUSDT'] as const;
const BUY_EVENTS_BSC = ['BuyByETH', 'BuyByUSDC', 'BuyByUSDT'] as const;
const BUY_EVENTS_V2 = ['buy'] as const;

export const useWatchBuyEvents = ({ onBuyEvent }: UseWatchBuyEventsProps) => {
  const { address } = useAccount();
  const { nodeVersion } = useAppSelector(state => state.app);
  const { projectInfo } = useAppSelector(state => state.project);

  const handleBuyEvent = useCallback(
    async (logs: any) => {
      if (logs[0]?.address.toLowerCase() === address?.toLowerCase()) return;

      if (onBuyEvent) {
        await onBuyEvent();
      }
    },
    [address, onBuyEvent],
  );

  // Register event listeners for all buy events
  // NOTE: BSC Specific
  const buyEvents = nodeVersion === 'v1' ? BUY_EVENTS_BSC : BUY_EVENTS_V2;
  const abi = nodeVersion === 'v1' ? BSC_ABI : SALE_ABI;
  const saleAddress = (nodeVersion === 'v1' ? NODE_SALE_V1_SC_ADDRESS : projectInfo?.sale) as `0x${string}`;

  buyEvents.forEach(eventName => {
    useWatchContractEvent({
      fromBlock: 52391645n, // HACK: MAGIC NUMBER - Set polling from latest block to reduce CUs
      address: saleAddress,
      abi: abi,
      eventName,
      onLogs: handleBuyEvent,
      poll: true,
      pollingInterval: 15_000, // HACK: MAGIC NUMBER - Set polling interval to 15s to reduce number of requests to Alchemy
    });
  });
};
